import React, { useEffect } from "react";
import Grid from '@mui/material/Grid2';
import { useParams, useNavigate } from "react-router-dom";
import { useStoreActions, useStoreState } from 'easy-peasy';
import {
	Box,
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import './Header.css';

const Header = () => {
	const { orgId } = useParams();
	const navigate = useNavigate();
	const theme = useTheme();
	const brandingData = useStoreState((state) => state?.paCheck?.brandingData);
	const commonAction = useStoreActions((actions) => actions.common);
	const paCheckAction = useStoreActions((actions) => actions.paCheck);

	useEffect(() => {
		paCheckAction.getBrandingData(orgId)
			.then(() => {
				// Handle successful branding data retrieval
			})
			.catch((error) => {
				// console.error("Error fetching branding data:", error.response);
				if (error.response && error.response.status === 441 && error.response.data && error.response.data.error_type === "invalid_tenant_id") {
					commonAction.setSubmitSnackbar({
						open: true,
						status: false,
						messages: error?.response?.data?.error,
					});
					navigate(`/`);
				}
			});
		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	return (
		<Box component="section" className="headerBox">
			<Grid container className="container">
				{brandingData?.branding?.company_logo && (
					<Grid item size={{ xs: 12, sm: 6, md: 3.3 }} style={{borderRight: `2px solid ${theme.palette.primary.main}`, padding: '5px 0'}} className="providers-header-logo">
						<img src={brandingData?.branding?.company_logo} alt={brandingData?.branding?.custom_branding} style={{maxWidth: '220px'}} />
					</Grid>
				)}
				<Grid item size={{ xs: 12, sm: 6, md: 8.7 }} className="providers-header">
					<div className="providers-header-text" style={{paddingLeft: brandingData?.branding?.company_logo ? '32px' : '0px'}}>
						{brandingData?.branding?.custom_branding}
					</div>
				</Grid>
			</Grid>
		</Box>
	)
}    

Header.propTypes = {

};

export default Header;